import { useInView } from "react-intersection-observer"
import * as styles from "./styles.module.scss"
import cx from "classnames"
import LogoNerdwallet from "../../icons/LogoNerdwallet"
import React, { useRef, useState } from "react"

const Nerdwallet: React.FC = () => {
  const [ref, inView] = useInView({
    threshold: 0,
  })

  return (
    <section className={styles.nerdwallet}>
      <div className={styles.pagePadding}>
        <div className={styles.container}>
          <div
            className={cx({
              [styles.logo]: true,
              [styles.inView]: inView,
            })}
            ref={ref}
          >
            <LogoNerdwallet />
          </div>
          <div className={styles.message}>
            <p className={styles.eyebrow}>Nerdwallet Awards 2018 Winner</p>
            <h4 className={styles.heading}>
              Best Online Mortgage Lenders for Customer Service
            </h4>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Nerdwallet
